/** Nota de 1 a 5 (C-22). Somente leitura quando não há onChange. */
export default function Stars({ value, onChange, size }: { value: number; onChange?: (v: number) => void; size?: number }) {
  return (
    <div className="stars" role={onChange ? 'radiogroup' : 'img'} aria-label={`Nota ${value} de 5`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          role={onChange ? 'radio' : undefined}
          aria-checked={onChange ? value === n : undefined}
          aria-label={`${n} estrela${n > 1 ? 's' : ''}`}
          className={n <= value ? 'on' : ''}
          style={size ? { fontSize: size } : undefined}
          onClick={() => onChange?.(n)}
          disabled={!onChange}
        >
          ★
        </button>
      ))}
    </div>
  );
}
